import { autoserializeAs, autoserializeAsArray } from 'dcerialize';

import { RestItemList } from './rest-item';

/**
 * Grant CRUD class
 */
export class Grant {
  /**
   * ID
   */
  @autoserializeAs(() => Number) _id!: number;

  /**
   * Grant name
   */
  @autoserializeAs(() => String) name: string;

  /**
   * Grant percentage
   */
  @autoserializeAs(() => Number) percentage: number;

  /**
   * Date since the grant is valid
   */
  @autoserializeAs(() => Date) startDate: Date;

  /**
   * Date until the grant is valid
   */
  @autoserializeAs(() => Date) endDate: Date;

  /**
   * Grant campaings
   */
  @autoserializeAsArray(() => String) campaings?: string[];

  /**
   * Grant faculties
   */
  @autoserializeAsArray(() => Number) faculties?: number[];

  /**
   * Grant typeEuroinnovaIds
   */
  @autoserializeAsArray(() => Number) typeEuroinnovaIds?: number[];

  constructor(
    name: string,
    percentage: number,
    startDate: Date,
    endDate: Date,
    campaings?: string[],
    faculties?: number[],
    typeEuroinnovaIds?: number[]
  ) {
    this.name = name;
    this.percentage = percentage;
    this.startDate = startDate;
    this.endDate = endDate;
    this.campaings = campaings;
    this.faculties = faculties;
    this.typeEuroinnovaIds = typeEuroinnovaIds;
  }
}

/**
 * Grant list class
 */
export class GrantList extends RestItemList<Grant> {
  /**
   * Grant list
   */
  @autoserializeAsArray(() => Grant) items: Grant[];

  /**
   * Number of entries in list
   */
  @autoserializeAs(() => Number) total: number;

  constructor(items: Grant[] = [], total = 0) {
    super();
    this.items = items;
    this.total = total;
  }
}
